import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import "../../asstes/styles/privateCouncilWhatThisIsNot.scss";
import AnimationEffect from "./AnimationEffect";

const textVariant = {
    hidden: { opacity: 0, y: 40 },
    visible: (i) => ({
        opacity: 1,
        y: 0,
        transition: {
            delay: i * 0.3,
            duration: 0.8,
            ease: "easeOut",
        },
    }),
};
const cardVariants = {
    hidden: {
        opacity: 0,
        y: 60,
    },
    visible: (i) => ({
        opacity: 1,
        y: 0,
        transition: {
            delay: i * 0.15,
            duration: 0.7,
            ease: "easeOut",
        },
    }),
};
const buttonVariant = {
    hidden: { opacity: 0, x: 60 },
    visible: {
        opacity: 1,
        x: 0,
        transition: { duration: 0.8, ease: "easeOut", delay: 0.6 },
    },
};

const cardContainer = {
    hidden: {},
    visible: {
        transition: {
            staggerChildren: 0.2,
        },
    },
};

const cardItem = {
    hidden: { opacity: 0, y: 40 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.6, ease: "easeOut" },
    },
};

const services = [
    {
        title: "Branding and Identity Design",
        desc: "We craft distinctive brand identities that resonate deeply and stand the test of time.",
    },
    {
        title: "Website Design and Development",
        desc: "Elegant, high-performance digital experiences built with precision and clarity.",
    },
    {
        title: "Advertising and Marketing Campaigns",
        desc: "Strategic campaigns designed to captivate audiences and drive measurable growth.",
    },
    {
        title: "Creative Consulting and Development",
        desc: "Guiding innovation with refined thinking and world-class creative execution.",
    },
];

const PrivateCouncilWhatThisIsNot = () => {
    return (
        <>
            <section className="pc-what-this-not pc-dark-bg pt-5 pb-0">
                <AnimationEffect />
                <div className="container">
                    <div className="pc-title-sec">
                        <h1 className="pc-title">What <span className="bold-w">This</span> Is <span className="bold-w">Not</span></h1>
                        <p>This is not for optimization, personal development, performance enhancement, or guidance-seeking. If reassurance, validation, or instruction is required, the Council is not appropriate.</p>
                    </div>

                    <div className="row pc-services-grid m-0">

                        <motion.div
                            className="col-md-6 col-lg-3 pc-services-grid-item p-0"
                            initial={{ opacity: 0, y: 60 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6 }}
                            viewport={{ once: true }} whileHover={{ y: -4 }}
                        >
                            <a href="javascript:void(0);" className="pc-service-card pc-up">
                                <h2 className="pc-card-title">Optimization</h2>

                                <p>
                                    Improve workflows efficiently <br />
                                    Increase productivity levels <br />
                                    Achieve smarter business growth
                                </p>

                                <div className="pc-button pc-arrow-place">
                                    <span className="pc-arrow">
                                        <i className="bi bi-arrow-right"></i>
                                    </span>
                                </div>
                            </a>
                        </motion.div>

                        <motion.div
                            className="col-md-6 col-lg-3 pc-services-grid-item p-0"
                            initial={{ opacity: 0, y: 60 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.7, delay: 0.1 }}
                            viewport={{ once: true }} whileHover={{ y: -4 }}
                        >
                            <a href="javascript:void(0);" className="pc-service-card pc-up">
                                <h2 className="pc-card-title">
                                    Personal <br />Development
                                </h2>

                                <p>
                                    Build confidence and skills <br />
                                    Enhance personal capabilities <br />
                                    Unlock your full potential
                                </p>

                                <div className="pc-button pc-arrow-place">
                                    <span className="pc-arrow">
                                        <i className="bi bi-arrow-right"></i>
                                    </span>
                                </div>
                            </a>
                        </motion.div>

                        <motion.div
                            className="col-md-6 col-lg-3 pc-services-grid-item p-0"
                            initial={{ opacity: 0, y: 60 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8, delay: 0.2 }}
                            viewport={{ once: true }} whileHover={{ y: -4 }}
                        >
                            <a href="javascript:void(0);" className="pc-service-card pc-up">
                                <h2 className="pc-card-title">
                                    Performance <br />Enhancement
                                </h2>

                                <p>
                                    Boost overall team efficiency <br />
                                    Improve measurable outcomes <br />
                                    Deliver consistent high results
                                </p>

                                <div className="pc-button pc-arrow-place">
                                    <span className="pc-arrow">
                                        <i className="bi bi-arrow-right"></i>
                                    </span>
                                </div>
                            </a>
                        </motion.div>

                        <motion.div
                            className="col-md-6 col-lg-3 pc-services-grid-item p-0"
                            initial={{ opacity: 0, y: 60 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.9, delay: 0.3 }}
                            viewport={{ once: true }}
                            whileHover={{ y: -4 }}
                        >
                            <a href="javascript:void(0);" className="pc-service-card pc-up">
                                <h2 className="pc-card-title">
                                    Guidance <br />Seeking
                                </h2>

                                <p>
                                    Receive expert strategic advice <br />
                                    Discover the right direction <br />
                                    Make informed growth decisions
                                </p>

                                <div className="pc-button pc-arrow-place">
                                    <span className="pc-arrow">
                                        <i className="bi bi-arrow-right"></i>
                                    </span>
                                </div>
                            </a>
                        </motion.div>

                    </div>

                </div>
            </section>
        </>
    );
};

export default PrivateCouncilWhatThisIsNot;